/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const ContainerNormalSize = styled.button`
  cursor: pointer;
  border: none;
  padding: 0;
  height: ${({ btnSize }) => btnSize};
  width: ${({ btnSize }) => btnSize};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    width: ${({ iconSize }) => iconSize};
    height: ${({ iconSize }) => iconSize};
  }
  :disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }

  ${({ visualType }) => {
    if (visualType === 'primary') {
      return css`
        background-color: ${Palette.Primary._500};
        box-shadow: 0px 2px 2px 0px rgba(28, 53, 106, 0.05);
        svg {
          fill: #ffffff;
        }
        :hover {
          background-color: ${Palette.Primary._600};
          box-shadow: 0px 2px 2px 0px rgba(28, 53, 106, 0.05);
        }
        :active {
          box-shadow: 0px 0px 0px 3px ${Palette.Primary._100};
          background-color: ${Palette.Primary._500};
          svg {
            fill: ${Palette.Primary._100};
          }
        }
        :disabled {
          box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0);
          background-color: ${Palette.Primary._500};
        }
      `;
    }
    if (visualType === 'secondary') {
      return css`
        border: 1px solid ${Palette.PrimaryGray._200};
        background: #ffffff;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
        svg {
          fill: ${Palette.Primary._500};
        }
        :hover {
          background-color: #ffffff;
          box-shadow: 0px 2px 2px 0px rgba(28, 53, 106, 0.05);
          border: 1px solid ${Palette.Primary._300};
        }
        :active {
          border: 1px solid ${Palette.Primary._300};
          background: ${Palette.Primary._000};
          box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
        }
        :disabled {
          border: 1px solid ${Palette.PrimaryGray._200};
          background: #ffffff;
          box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
        }
      `;
    }
    if (visualType === 'tertiary') {
      return css`
        background: rgba(255, 255, 255, 0);
        svg {
          fill: ${({ isDefaultMuted }) =>
            isDefaultMuted ? `${Palette.PrimaryGray._400}` : `${Palette.PrimaryGray._500}`};
        }
        :hover {
          background: ${Palette.PrimaryGray._100};
          svg {
            fill: ${({ isDestructive }) =>
              isDestructive ? `${Palette.Red._500}` : `${Palette.Primary._500}`};
          }
        }
        :active {
          background: var(--White, #fff);
          box-shadow: 0px 0px 0px 3px rgba(59, 137, 246, 0.16);
        }
        :disabled {
          background: rgba(255, 255, 255, 0);
          svg {
            fill: ${Palette.PrimaryGray._500};
          }
        }
      `;
    }
    if (visualType === 'internal') {
      return css`
        background: transparent;
        svg {
          fill: ${Palette.PrimaryGray._400};
        }
        :hover {
          svg {
            fill: ${Palette.Primary._500};
          }
        }
        :active {
          svg {
            fill: ${Palette.Primary._700};
          }
        }
      `;
    }
  }}
  ${({ pressed, visualType }) =>
    pressed &&
    visualType !== 'primary' &&
    css`
      visibility: visible !important;
      border: 1px solid ${Palette.Primary._300};
      background: ${Palette.Primary._000};
      svg {
        fill: ${Palette.Primary._500};
      }
    `}
`;
